import React from "react";
import JumboLayout from "@jumbo/components/JumboLayout";
import useJumboLayout from "@jumbo/hooks/useJumboLayout";
import layoutConfig from "./layoutConfig";
import Div from "@jumbo/shared/Div/Div";
import { Link } from "react-router-dom";
import Footer from "app/components/Footer";

const PublicPage = ({ children }) => {
  const { setJumboLayoutOptions } = useJumboLayout();

  React.useEffect(() => {
    setJumboLayoutOptions(layoutConfig);
  }, []);

  return (
    <JumboLayout>
      <Div className={`page-wrapper login`}>
        <Div
          sx={{
            position: "relative",
            zIndex: 1,
            mb: "50px",
            justifyContent: "center",
          }}
        >
          <Link href="#" underline="none" sx={{ display: "inline-flex" }}>
            <Div className="bg-custom-logo">
              <img src={`/images/logo-generali.png`} width={150} height={122} />
            </Div>
          </Link>
        </Div>
        {children}
      </Div>
      <Footer />
    </JumboLayout>
  );
};

export default PublicPage;
